import React from 'react';

import ContextMenuList, {
	ContextMenuItem,
} from '~/components/context-menu-list/context-menu-list';

import styles from '~/components/context-menu-button/context-menu-button.module.scss';

interface Props {
	items: ContextMenuItem[];
	disabled?: boolean;
}

interface State {
	/**
	 * id used to tie the <button> and list together for accessibility.
	 * NOTE: Currently not tested/used.
	 */
	id: string;
	isOpen: boolean;
}

export class ContextMenuButton extends React.Component<Props, State> {
	private static Uid = 0;

	private readonly refButtonEl = React.createRef<HTMLButtonElement>();

	private readonly refListContainerEl = React.createRef<HTMLDivElement>();

	constructor(props: Props) {
		super(props);
		this.state = {
			id: 'ContextMenuButton_' + ContextMenuButton.Uid,
			isOpen: false,
		};
		ContextMenuButton.Uid++;
	}

	private readonly onClickButton = (e: React.MouseEvent): void => {
		// NOTE: Jake: 2019-10-02
		// preventDefault/stopPropagation is normally a code-smell.
		// However, I need these so that I can place it inside th
		// <entity-search> which is currently a clickable <div>
		// (that also needs to be changed to something else!)
		e.preventDefault();
		e.stopPropagation();
		if (this.isDisabled()) {
			return;
		}
		this.setState((state, props) => {
			return {
				isOpen: state.isOpen ? false : true,
			};
		});
	};

	private readonly isDisabled = (): boolean => {
		return (
			this.props.disabled ||
			!this.props.items ||
			this.props.items.length === 0
		);
	};

	private readonly onClose = (target: HTMLElement | undefined): void => {
		const { isOpen } = this.state;
		if (
			!isOpen ||
			// Ignore action if we clicked the button or menu item
			target === this.refButtonEl.current ||
			!this.refButtonEl.current ||
			this.refButtonEl.current.contains(target)
		) {
			return;
		}
		this.setState({
			isOpen: false,
		});
	};

	public render() {
		const { items } = this.props;
		const { id, isOpen } = this.state;
		return (
			<div className={styles.root}>
				<button
					className={[
						// NOTE: Jake: 2019-10-02
						// Would like to remove implicit dependency on Bootstrap/OneUI
						// in the future. Ideally have a <Button> component that would
						// give us the behaviour we need. That way we could choose to
						// either feed that into OneUI or roll our own.
						'btn',
						'btn-primary',
						'i-btn',
						styles.button,
					].join(' ')}
					type="button"
					id={id}
					aria-haspopup="true"
					aria-expanded={isOpen ? 'true' : 'false'}
					onClick={this.onClickButton}
					disabled={this.isDisabled()}
					ref={this.refButtonEl}
				>
					<i className="fas fa-bars" aria-hidden="true" />
				</button>
				{
					// NOTE: Jake: 2019-08-13 - WEBUI-2182
					// We are using "show.bind" instead of "if.bind" so that our current
					// KeyboardShortcut logic still works with context menu items.
				}
				<div
					className={[
						styles.menu,
						isOpen ? styles['menu--show'] : '',
					].join(' ')}
					ref={this.refListContainerEl}
				>
					<ContextMenuList
						updateDirOnChange={isOpen}
						items={items}
						onClose={this.onClose}
					/>
				</div>
			</div>
		);
	}
}
